var map = {
	"./de-DE.json": 2271,
	"./en-US.json": 2272,
	"./es-MX.json": 2273,
	"./fr-FR.json": 2274,
	"./ja-JA.json": 2275,
	"./ko-KR.json": 2276,
	"./pt-BR.json": 2277,
	"./th-TH.json": 2278,
	"./zh-CN.json": 2279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1185;